import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Table from "../../components/Table/Table";
import Tabs from "../../components/Tabs/Tabs";
import data_tab_data from "../../assets/mockedData/data_tab_data";
import { useLocation } from "react-router-dom";
import { savePathToLocalStorage } from "../../utils/helpers";

const DataConfig = () => {
  savePathToLocalStorage();
  const filterConfig = () => {
    console.log("search");
  };

  return (
    <div className="settings-main main-content">
      <Header title="Config" searchFunction={filterConfig} />
      <div className="main-content-flex">
        <Tabs data={data_tab_data} />
        <div style={{ width: "100%" }}>
          <p style={{ textTransform: "uppercase", margin: "0 auto" }}>
            work in progress
          </p>
        </div>
      </div>
    </div>
  );
};

export default DataConfig;
